import React, { useEffect, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getHelpDataContent, isEmptyObject, isEmptyEvery } from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { getNeedHelpView } from '../Utils/NeedHelpUtils';
import { useHistory } from 'react-router-dom';
import { dispatchGetContentHelpCallAction } from 'common/utilities/orderProcessingSummaryUtils';

const NeedHelp = props => {
  const history = useHistory();
  const { isOpen, handleClose, isModalView = true, showOrderSummaryHeader = false, orderHistoryPage = false } = props;
  const dispatch = useDispatch();

  const { userOrderState } = useContext(UserOrderContext);
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW))
    : userOrderState.dispositionNew;

  const { type, store, orderDetails = {} } = isEmptyObject(dispositionNew) ? dispositionNew : {};
  const { helpReducer, orderReducer, postOrderReducer } = useSelector(data => data);
  const contentData = getHelpDataContent(helpReducer.helpResponse || null);

  const deliveryPartner = orderHistoryPage
    ? undefined
    : orderReducer?.response?.order?.deliveryPartners || postOrderReducer?.orderAccepted?.deliveryPartners;
  const [deliveryPartners, setDeliveryPartners] = useState(deliveryPartner);

  useEffect(() => {
    dispatchGetContentHelpCallAction(dispatch);
    setDeliveryPartners(deliveryPartner);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    isEmptyObject(contentData) &&
    getNeedHelpView({
      contentData,
      service: showOrderSummaryHeader ? orderDetails?.type : type,
      store: showOrderSummaryHeader ? orderDetails?.store : store,
      isOpen,
      handleClose,
      isModalView,
      history,
      deliveryPartner: deliveryPartners,
    })
  );
};

export default NeedHelp;
